module.exports = __webpack_public_path__ + "static/media/Mar_2026_3.e9f1fa3f.webp";